import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoTNVED14 extends Component {

    render() {
        const { code14 } = this.props;
        return (
            <CodeInfoSection title='Дополнительный код'
                table={{
                    headers: [
                        'Код',
                        'Описание',
                        'Нормативный документ'
                    ],
                    rows: code14.map(({ code = '', description = '', order_number, order_date, orders_info }) => ([
                        code,
                        description + ' ',
                        formatOrder(order_number, order_date, orders_info),
                    ]))
                }}
            />
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoTNVED14.js